import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  value: number;
  index: number;
} & Omit<BoxProps, 'children'>;

const TabPanel = ({ children, value, index, ...props }: Props) => (
  <Box role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...props}>
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </Box>
);

export default TabPanel;
